// src/screens/AdminSubscribers/AdminSubscribers.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { auth, db } from '../../firebase/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { collection, doc, getDoc, getDocs, orderBy, query } from 'firebase/firestore';
import './AdminSubscribers.css';

export default function AdminSubscribers() {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  // trackea sesión
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      setUser(u);
    });
    return () => unsub();
  }, []);

  // chequear si es admin mirando /admins/{uid}
  useEffect(() => {
    (async () => {
      if (!user) { setIsAdmin(false); setLoading(false); return; }
      try {
        const snap = await getDoc(doc(db, 'admins', user.uid));
        setIsAdmin(snap.exists());
      } finally {
        setLoading(false);
      }
    })();
  }, [user]);

  // cargar suscriptores si es admin
  useEffect(() => {
    if (!isAdmin) return;
    (async () => {
      setLoading(true);
      try {
        const q = query(collection(db, 'subscribers'), orderBy('consentAt', 'desc'));
        const snap = await getDocs(q);
        const list = snap.docs.map(d => {
          const data = d.data();
          const ts = data.consentAt?.toDate?.() || null;
          return {
            id: d.id,
            email: data.email || '',
            name: data.name || '',
            uid: data.uid || '',
            when: ts ? ts.toISOString() : '',
            source: data.source || '',
            topics: Array.isArray(data.topics) ? data.topics.join(', ') : '',
          };
        });
        setRows(list);
      } finally {
        setLoading(false);
      }
    })();
  }, [isAdmin]);

  if (!user) return <div className="admin-wrap"><p>Ingresá con tu usuario.</p></div>;
  if (!isAdmin) return <div className="admin-wrap"><p>No tenés permisos para ver esta página.</p></div>;

  const exportCSV = () => {
    const header = ['email','name','uid','consentAt','source','topics'];
    const csv = [header.join(','), ...rows.map(r => (
      [r.email, r.name, r.uid, r.when, r.source, `"${r.topics}"`].join(',')
    ))].join('\n');

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = 'subscribers.csv'; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="admin-wrap">
      <h1 className='admin-title'>Suscriptores</h1>
      <div className="admin-actions">
        <button className="admin-button" type="button" onClick={exportCSV} disabled={loading || rows.length === 0}>
          Exportar CSV
        </button>
      </div>
      {loading ? <p>Cargando…</p> : (
        rows.length === 0 ? <p>Sin suscriptores todavía.</p> : (
          <div className="table-scroll">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Nombre</th>
                  <th>UID</th>
                  <th>Fecha</th>
                  <th>Fuente</th>
                  <th>Topics</th>
                </tr>
              </thead>
              <tbody>
                {rows.map(r => (
                  <tr key={r.id}>
                    <td>{r.email}</td>
                    <td>{r.name}</td>
                    <td className="mono">{r.uid}</td>
                    <td className="mono">{r.when}</td>
                    <td>{r.source}</td>
                    <td>{r.topics}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
}
